<div class="row justify-content-md-center no-gutters greyBgBody text-center marL10">
    <app-loader-icon *ngIf="showEmailLoader"></app-loader-icon>
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 manageMailBoxSection whiteBg">
                <h5 class="sectionTitleBig text-left">Email Management</h5>
                <div class="row">
                    <div class="col-3 display_inlineBlock align-section-left">
                        <label for="emailCategorySelect">Email Category</label>
                        <div class="form-group">
                            <select class="form-control custom-select" id="emailCategorySelect" name=""
                                [(ngModel)]="selectedTemplates" (change)="getfilteredtemplatelist(selectedTemplates)">
                                <option value="Email_Catagory">Email Category</option>
                                <option *ngFor="let template of emailCatagory" value="{{template?.emailCatagory}}">
                                    {{template?.emailCatagory}}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>

                        </div>
                    </div>
                    <div class="col-3 display_inlineBlock align-section-left">
                        <div class="row">
                            <div class="col-12">
                                <label for="emailTitle">Email Title</label>
                                <div class="form-group">
                                    <input type="text" id="emailTitle" [(ngModel)]="selectedEmailTitle"
                                        (keyup.enter)="searchFilters(selectedTemplates,selectedEmailTitle)" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-12 separateLineTop">
                    <div class="col-12 ">
                        <div class="text-right">
                            <button type="button" (click)="searchFilters(selectedTemplates,selectedEmailTitle)"
                                class="clickBtn mr10"
                                [disabled]="selectedEmailTitle.length <3">Search</button>
                            <button type="button" (click)="clearEmailFields()" class="clickBtn"
                                [disabled]="selectedTemplates== 'Email_Catagory' && selectedEmailTitle.length <1">Clear</button>
                        </div>
                    </div>
                </div>

                <div class="col-12 display_inlineBlock separateLineTop">
                    <div class="manageMailBoxDatGridArea searchDataTable">
                        <app-smart-data-grid [sampleColumns]="sampleColumns" [sampleData]="filteredTemplates"
                            [allowCheckbox]="false" [iseventRegistered]="true" [allowPagination]="true"
                            [isClientSidePagination]="true" (handlePageChangeEvent)="updateListData($event)"
                            [totalRecord]="totalRecords" [pageSize]="10"></app-smart-data-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
